/**
 * The app's one text match, for every type-to-search list: the filter dropdowns
 * (SearchPick, MultiSelect) and the header's search (GlobalSearch).
 *
 * By words in any order, so "sarah barr", "barr sarah" and "barr, s" all find
 * "BARR, Sarah": names are stored "Last, First" and nobody types them that way.
 */
export const words = (s: string) =>
  s
    .toLowerCase()
    .split(/[\s,]+/)
    .filter(Boolean)

/** Every word of the query appears somewhere in the label. */
export function matches(label: string, query: string): boolean {
  const q = words(query)
  if (q.length === 0) return true
  const l = label.toLowerCase()
  return q.every((w) => l.includes(w))
}
